import Grid from '@mui/material/Grid';
import {
  EntityConsumedApisCard,
  EntityProvidedApisCard,
} from '@backstage/plugin-api-docs';
import {
  EntityHasSubcomponentsCard,
  EntityOrphanWarning,
  EntityProcessingErrorsPanel,
  EntitySwitch,
  hasCatalogProcessingErrors,
  isComponentType,
  isKind,
  isOrphan,
} from '@backstage/plugin-catalog';
import { EntityCatalogGraphCard } from '@backstage/plugin-catalog-graph';
import {
  and,
  canConsumeAPIs,
  canProvideAPIs,
  EnhancedEntityLinksCard,
  isContainer,
  not,
  TeamContactsCard,
} from '@mb.io/core-components';

import { EntityAboutCard } from '../../about-card';
import { SeamlessHasSubcomponentsCard } from '../../seamless/SeamlessHasSubcomponentsCard';
import { EntityEndOfLifeCard } from '@mercedes-benz/endoflife';
import { ReactElement } from 'react';
import { TechInsightsQuickView } from '@mercedes-benz/tech-insights';

type OverviewContentProps = {
  children: ReactElement | ReactElement[];
  hideEmptyLinks?: boolean;
};

export const OverviewContent = ({
  children,
  hideEmptyLinks,
}: OverviewContentProps) => (
  <Grid container spacing={3} alignItems="stretch" direction="row">
    <EntitySwitch>
      <EntitySwitch.Case if={isOrphan}>
        <Grid item xs={12}>
          <EntityOrphanWarning />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>

    <EntitySwitch>
      <EntitySwitch.Case if={hasCatalogProcessingErrors}>
        <Grid item xs={12}>
          <EntityProcessingErrorsPanel />
        </Grid>
      </EntitySwitch.Case>
    </EntitySwitch>
    <Grid item md={6} xs={12} className="grid-item">
      <EntityAboutCard />
    </Grid>

    <Grid item className="grid-item" md={6} xs={12}>
      <Grid
        container
        alignItems="stretch"
        direction="column"
        wrap="nowrap"
        style={{ padding: 0 }}
      >
        <Grid item xs={12} style={{ padding: 0 }}>
          <TeamContactsCard />
        </Grid>
        <Grid
          item
          className="grid-item"
          xs={12}
          style={{ padding: 0, paddingTop: '1em' }}
        >
          <EnhancedEntityLinksCard hideEmpty={hideEmptyLinks} />
        </Grid>
      </Grid>
    </Grid>
    {children}
  </Grid>
);

export const GenericOverviewContent = (
  <OverviewContent>
    <Grid item xs={12} className="grid-item">
      <EntityCatalogGraphCard height={400} maxDepth={1} />
    </Grid>
  </OverviewContent>
);

export const ComponentOverviewContent = (
  <OverviewContent>
    <>
      <EntitySwitch>
        <EntitySwitch.Case if={isComponentType('service')}>
          <Grid item xs={12} className="grid-item">
            <TechInsightsQuickView />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <Grid item xs={12} className="grid-item">
        <EntityEndOfLifeCard />
      </Grid>

      <Grid item xs={12} className="grid-item">
        <EntityCatalogGraphCard height={400} maxDepth={1} />
      </Grid>
      <EntitySwitch>
        <EntitySwitch.Case if={canProvideAPIs}>
          <Grid item md={12} xl={6}>
            <EntityProvidedApisCard />
          </Grid>
        </EntitySwitch.Case>

        <EntitySwitch.Case if={canConsumeAPIs}>
          <Grid item md={12} xl={6}>
            <EntityConsumedApisCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>

      <EntitySwitch>
        <EntitySwitch.Case if={and(isKind('seamless'), not(isContainer))}>
          <Grid item md={12} xl={6}>
            <SeamlessHasSubcomponentsCard variant="gridItem" />
          </Grid>
        </EntitySwitch.Case>
        <EntitySwitch.Case if={not(isKind('seamless'))}>
          <Grid item md={12} xl={6}>
            <EntityHasSubcomponentsCard />
          </Grid>
        </EntitySwitch.Case>
      </EntitySwitch>
    </>
  </OverviewContent>
);
